import { useState, useEffect } from "react";
import "../../css/UserEditModal.css";
import "../../css/SiteAdminModals.css";

interface ExpirationModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentDate: string;
    onConfirm: (newDate: string) => void;
}

export const ExpirationModal = ({ isOpen, onClose, currentDate, onConfirm }: ExpirationModalProps) => {
    const [date, setDate] = useState(currentDate);

    useEffect(() => { setDate(currentDate); }, [currentDate]);

    if (!isOpen) return null;

    return (
        <div className="uem-overlay" onClick={onClose}>
            <div className="uem-modal" onClick={(e) => e.stopPropagation()}>
                <div className="uem-header">
                    <h2>Manage Expiration Date</h2>
                    <button className="uem-close" onClick={onClose} aria-label="Close modal">×</button>
                </div>
                <div className="uem-body">
                    <div className="uem-date-field">
                        <label>Subscription Expiration Date</label>
                        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                        <p className="uem-date-hint">Setting a past date will immediately expire the account.</p>
                    </div>
                </div>
                <div className="uem-footer">
                    <button type="button" className="uem-btn-cancel" onClick={onClose}>Cancel</button>
                    <button type="button" className="uem-btn-submit" disabled={!date} onClick={() => onConfirm(date)}>
                        Update Date
                    </button>
                </div>
            </div>
        </div>
    );
};
